/* istanbul ignore next: wip build */
module.exports = process.env.NODE_ENV === 'production'
  ? 'transformers'
  : 'transformers'
